import {Floor} from '@lib/store';
import {TFunction} from 'i18next';
import {
  SECTION_ID_ACTIVITY_TYPE,
  SECTION_ID_DESK_AMENITY,
  SECTION_ID_FLOORS,
  constructActivityTypeFilter,
  constructDeskAmenityFilter,
  constructFloorFilter,
} from '../filterConstructors';
import {DeskAmenity, ActivityType} from '@lib/infrastructure';

export const constructWorkspacesFilter = (
  floors: Floor[],
  availableDeskAmenities: DeskAmenity[],
  availableActivityTypes: ActivityType[],
  getDeskAmenityIconName: (id: DeskAmenity) => string,
  t: TFunction,
) => {
  const floorFilters = constructFloorFilter(floors, t);
  const deskAmenitiesFilter = constructDeskAmenityFilter(availableDeskAmenities, getDeskAmenityIconName, t);
  const activityTypesFilter = constructActivityTypeFilter(availableActivityTypes, t);

  return {
    [SECTION_ID_FLOORS]: floorFilters,
    [SECTION_ID_DESK_AMENITY]: deskAmenitiesFilter,
    [SECTION_ID_ACTIVITY_TYPE]: activityTypesFilter,
  };
};
